module.exports = __webpack_public_path__ + "static/about-insta-4-a48b1385bd71cbaf7b19b3e6ed8cfca3.jpg";